import { useDocs } from "data/data";
import RadioButton from "../RadioButton";
import YearSelection from "components/YearSelection";


function Filter({ values, onChange }) {
    let today = new Date()

    const { stats, isLoading } = useDocs();

    let epaRegionNumbers = stats.epaRegions;
    let HqArray = epaRegionNumbers.splice(epaRegionNumbers.indexOf('HQ'), 1)
    epaRegionNumbers = epaRegionNumbers.sort((a, b) => a-b)
    epaRegionNumbers.push(HqArray)
    epaRegionNumbers = epaRegionNumbers.flat()

    let epaOptions = epaRegionNumbers.map((a) => {
        return <option key={a} value={a.toString()}>Region {a}</option>
    })
    let sourceOptions = ["ECHO", "R6ECHO", "PEER FOIA 1"]

    let documentOptions = stats.documents.map((a) => {
        return <option key={a} value={a}>{a}</option>
    })

    return (
        <div className="filter-grid">

            <div style={{gridColumn: "span 2"}}>
                <label className="field-label">Keyword Search</label>

                <input 
                    type="text" 
                    placeholder="Facility, keyword…" 
                    value={values.keyword}
                    onChange={e => onChange({ ...values, keyword: e.target.value })}
                />
            </div>

            <div>
                <YearSelection 
                    minValue={2021} 
                    maxValue={today.getFullYear()} 
                    filter={values}
                    onChange={e => onChange({...values, startYear: e.lowRange, endYear: e.highRange })}
                    />
            </div>

            <div>
                <label className="field-label">EPA Region</label>

                <select
                    value={values.epaRegion}
                    onChange={e => onChange({ ...values, epaRegion: e.target.value })}
                >
                    <option value="">All regions</option>
                    {epaOptions}
                </select>
            </div>

            <div>
                <label className="field-label">Enforcement Document</label>

                <select
                    value={values.epaType}
                    onChange={e => onChange({ ...values, epaType: e.target.value })}
                >
                    <option value="">All</option>
                    {documentOptions}
                </select>
            </div>

            <div style={{gridColumn: "span 2"}}>
                <label className="field-label">Environmental Statute</label>
                <RadioButton
                    filterValues={values}
                    onChange={onChange}
                    options={stats.statutes.map((label) => ({ label }))}
                    valueKey="statute"
                />
            </div>

            <div style={{gridColumn: "span 2"}}>
                <label className="field-label">FOIA Source</label>
                <RadioButton
                    filterValues={values}
                    onChange={onChange}
                    options={sourceOptions.map((label) => ({ label }))}
                    valueKey="foiaSource"
                />
            </div>

        </div>
    )
}

export default Filter;